import React, { memo, useEffect, useMemo, useRef, useState } from "react";

import { Bar, Line } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);
const LineChart = ({
  dataIn = [],
  labels,
  width,
  listColor,
  titleToolTip = "",
  hiddenLines,
  tooltipChat,
}) => {
  const dataChart = useMemo(() => {
    const result = [];
    dataIn?.map((data, i) => {
      return result.push({
        // label: titleToolTip,
        label: tooltipChat ? titleToolTip[i] : titleToolTip,
        data: data,
        backgroundColor: listColor[i],
        borderWidth: 2,
        borderColor: listColor[i],
        pointRadius: 0,
        pointBackgroundColor: "white", // Đặt màu nền của chấm
        pointBorderColor: listColor[i],
        cubicInterpolationMode: "monotone",
        datalabels: false,
        hidden: hiddenLines ? hiddenLines.includes(i) : null,
      });
    });
    return result;
  }, [dataIn, listColor, titleToolTip, hiddenLines, tooltipChat]);
  const data = {
    labels: labels,
    datasets: dataChart,
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      legend: false,
      stepSize: 5,
      //   tooltip: false,
    },
  };
  return (
    <div
      style={{ width: width, height: 400 }}
      className="chartTracKday wrapperChart"
    >
      <Line width={800} data={data} options={options} id="myChart" />
    </div>
  );
};

export default LineChart;
